import { Icon } from '@project44/manifest-ui-deprecated';

export const CarrierIcon = () => (
  <Icon sx={{ width: 20, height: 20, fill: 'none' }} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3334 3.41671H15.6667C16.5917 3.41671 17.3334 4.15837 17.3334 5.08337V14.25C17.3334 15.175 16.5917 15.9167 15.6667 15.9167H2.33335C1.40835 15.9167 0.666687 15.175 0.666687 14.25L0.67502 5.08337C0.67502 4.15837 1.40835 3.41671 2.33335 3.41671H5.66669V1.75004C5.66669 0.825041 6.40835 0.083374 7.33335 0.083374H10.6667C11.5917 0.083374 12.3334 0.825041 12.3334 1.75004V3.41671ZM7.33335 3.41671H10.6667V1.75004H7.33335V3.41671Z"
      fill="url(#paint0_linear_5244_230)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5244_230"
        x1="0.666687"
        y1="9.34588"
        x2="32.5978"
        y2="9.34588"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </Icon>
);

export const EventIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3333 1.50002V2.33335H4.66667V1.50002C4.66667 1.04169 4.29167 0.666687 3.83333 0.666687C3.375 0.666687 3 1.04169 3 1.50002V2.33335H2.16667C1.24167 2.33335 0.508333 3.08335 0.508333 4.00002L0.5 15.6667C0.5 16.5834 1.24167 17.3334 2.16667 17.3334H13.8333C14.75 17.3334 15.5 16.5834 15.5 15.6667V4.00002C15.5 3.08335 14.75 2.33335 13.8333 2.33335H13V1.50002C13 1.04169 12.625 0.666687 12.1667 0.666687C11.7083 0.666687 11.3333 1.04169 11.3333 1.50002ZM11.3333 9.83335H8.83333C8.375 9.83335 8 10.2084 8 10.6667V13.1667C8 13.625 8.375 14 8.83333 14H11.3333C11.7917 14 12.1667 13.625 12.1667 13.1667V10.6667C12.1667 10.2084 11.7917 9.83335 11.3333 9.83335ZM3 15.6667H13C13.4583 15.6667 13.8333 15.2917 13.8333 14.8334V6.50002H2.16667V14.8334C2.16667 15.2917 2.54167 15.6667 3 15.6667Z"
      fill="url(#paint0_linear_553_6784)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_553_6784"
        x1="0.5"
        y1="10.4167"
        x2="29.238"
        y2="10.4167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const LocationIcon = () => (
  <Icon sx={{ width: 20, height: 20 }} viewBox="0 0 12 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.166504 6.72078C0.166504 3.49578 2.77484 0.887451 5.99984 0.887451C9.22484 0.887451 11.8332 3.49578 11.8332 6.72078C11.8332 10.1958 8.14984 14.9874 6.6415 16.8124C6.30817 17.2124 5.69984 17.2124 5.3665 16.8124C3.84984 14.9874 0.166504 10.1958 0.166504 6.72078ZM3.9165 6.72078C3.9165 7.87079 4.84984 8.80412 5.99984 8.80412C7.14984 8.80412 8.08317 7.87079 8.08317 6.72078C8.08317 5.57078 7.14984 4.63745 5.99984 4.63745C4.84984 4.63745 3.9165 5.57078 3.9165 6.72078Z"
      fill="url(#paint0_linear_7497_6024)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7497_6024"
        x1="0.166504"
        y1="10.3791"
        x2="22.5183"
        y2="10.3791"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </Icon>
);

export const PartnersIcon = () => (
  <Icon sx={{ width: 20, height: 20 }} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.333 9.166a2.49 2.49 0 0 0 2.492-2.5 2.497 2.497 0 1 0-4.992 0c0 1.383 1.117 2.5 2.5 2.5Zm-6.666 0a2.49 2.49 0 0 0 2.491-2.5 2.497 2.497 0 1 0-4.992 0c0 1.383 1.117 2.5 2.5 2.5Zm0 1.667c-1.942 0-5.834.975-5.834 2.916v1.084a1 1 0 0 0 1 1H11.5a1 1 0 0 0 1-1v-1.084c0-1.941-3.892-2.916-5.833-2.916Zm6.666 0a9.73 9.73 0 0 0-.808.041c.967.7 1.642 1.642 1.642 2.875v1.084a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.084c0-1.941-3.892-2.916-5.834-2.916Z"
      fill="#3142C8"
    />
  </Icon>
);

export const PropertiesIcon = () => (
  <Icon sx={{ width: 20, height: 20, fill: 'none' }} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5ZM11.6667 7.91667H14.1667C14.625 7.91667 15 7.54167 15 7.08333C15 6.625 14.625 6.25 14.1667 6.25H11.6667C11.2083 6.25 10.8333 6.625 10.8333 7.08333C10.8333 7.54167 11.2083 7.91667 11.6667 7.91667ZM11.6667 13.75H14.1667C14.625 13.75 15 13.375 15 12.9167C15 12.4583 14.625 12.0833 14.1667 12.0833H11.6667C11.2083 12.0833 10.8333 12.4583 10.8333 12.9167C10.8333 13.375 11.2083 13.75 11.6667 13.75ZM5.83333 9.16667H8.33333C8.79167 9.16667 9.16667 8.79167 9.16667 8.33333V5.83333C9.16667 5.375 8.79167 5 8.33333 5H5.83333C5.375 5 5 5.375 5 5.83333V8.33333C5 8.79167 5.375 9.16667 5.83333 9.16667ZM8.33333 5.83333H5.83333V8.33333H8.33333V5.83333ZM5.83333 15H8.33333C8.79167 15 9.16667 14.625 9.16667 14.1667V11.6667C9.16667 11.2083 8.79167 10.8333 8.33333 10.8333H5.83333C5.375 10.8333 5 11.2083 5 11.6667V14.1667C5 14.625 5.375 15 5.83333 15ZM8.33333 11.6667H5.83333V14.1667H8.33333V11.6667Z"
      fill="url(#paint0_linear_3691_110601)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3691_110601"
        x1="2.5"
        y1="11.275"
        x2="31.238"
        y2="11.275"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </Icon>
);

export const ReferenceIcon = () => (
  <Icon sx={{ width: 20, height: 20, fill: 'none' }} viewBox="0 0 20 20">
    <path
      d="M17.5 8.33333H10.5417C9.85833 6.39167 8.00833 5 5.83333 5C3.075 5 0.833334 7.24167 0.833334 10C0.833334 12.7583 3.075 15 5.83333 15C8.00833 15 9.85833 13.6083 10.5417 11.6667H10.8333L12.5 13.3333L14.1667 11.6667L15.8333 13.3333L19.1667 9.96667L17.5 8.33333ZM5.83333 12.5C4.45833 12.5 3.33333 11.375 3.33333 10C3.33333 8.625 4.45833 7.5 5.83333 7.5C7.20833 7.5 8.33333 8.625 8.33333 10C8.33333 11.375 7.20833 12.5 5.83333 12.5Z"
      fill="url(#paint0_linear_3691_110577)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3691_110577"
        x1="0.833334"
        y1="10.85"
        x2="35.9575"
        y2="10.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </Icon>
);

export const VesselIcon = () => (
  <Icon sx={{ width: 20, height: 20, fill: 'none' }} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16248 3.33325H9.99581C11.3791 3.33325 12.4958 4.44992 12.4958 5.83325V6.66659H10.8291V5.41659C10.8291 5.18325 10.6458 4.99992 10.4125 4.99992H3.74581C3.51248 4.99992 3.32914 5.18325 3.32914 5.41659V10.4166C3.32914 10.6499 3.51248 10.8333 3.74581 10.8333H7.49581V14.9999H5.82914L4.35414 16.4749C4.12081 16.7083 3.75414 16.7083 3.52081 16.4749C3.28748 16.2416 3.28748 15.8749 3.52081 15.6416L4.16248 14.9999C2.77914 14.9999 1.66248 13.8833 1.66248 12.4999V5.83325C1.66248 4.44992 2.77914 3.33325 4.16248 3.33325ZM4.99581 12.4999C4.99581 12.0416 4.62081 11.6666 4.16248 11.6666C3.70414 11.6666 3.32914 12.0416 3.32914 12.4999C3.32914 12.9583 3.70414 13.3333 4.16248 13.3333C4.62081 13.3333 4.99581 12.9583 4.99581 12.4999ZM17.1375 8.04992C17.0208 7.71659 16.7041 7.49992 16.3291 7.49992H10.3375C9.95414 7.49992 9.64581 7.71659 9.52081 8.04992L8.33748 11.4749V15.8416C8.33748 16.2999 8.71248 16.6666 9.17081 16.6666C9.62914 16.6666 10.0041 16.2916 10.0041 15.8333V14.9999H16.6708V15.8333C16.6708 16.2916 17.0458 16.6666 17.5041 16.6666C17.9625 16.6666 18.3291 16.2999 18.3375 15.8416L18.3291 11.4749L17.1375 8.04992ZM16.0375 8.33325H10.6375C10.4541 8.33325 10.2958 8.44992 10.2541 8.61658L9.67914 10.2833C9.58748 10.5499 9.78748 10.8333 10.0708 10.8333H16.6125C16.8958 10.8333 17.0958 10.5499 17.0041 10.2833L16.4291 8.61658C16.3708 8.44992 16.2125 8.33325 16.0375 8.33325ZM9.99581 13.3333C9.53748 13.3333 9.16248 12.9583 9.16248 12.4999C9.16248 12.0416 9.53748 11.6666 9.99581 11.6666C10.4541 11.6666 10.8291 12.0416 10.8291 12.4999C10.8291 12.9583 10.4541 13.3333 9.99581 13.3333ZM15.8291 12.4999C15.8291 12.9583 16.2041 13.3333 16.6625 13.3333C17.1208 13.3333 17.4958 12.9583 17.4958 12.4999C17.4958 12.0416 17.1208 11.6666 16.6625 11.6666C16.2041 11.6666 15.8291 12.0416 15.8291 12.4999Z"
      fill="url(#paint0_linear_3653_111885)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3653_111885"
        x1="1.66248"
        y1="11.1333"
        x2="33.6095"
        y2="11.1333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0072EC" />
        <stop offset="0.854167" stopColor="#4E00C6" />
        <stop offset="1" stopColor="#8C18E2" />
      </linearGradient>
    </defs>
  </Icon>
);
